/* eslint-disable */
import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import dayjs from "utils/dayjs";
import queryString from 'query-string';
import i18n from "locales/i18n";

import { Box, Button, CircularProgress, FormControl } from '@mui/material';
import { DataGridPro, koKR, enUS, zhCN } from '@mui/x-data-grid-pro';
import PageInfo from 'components/PageInfo';
import { getEquipmentCategoriesByQuery } from 'components/axios/equipmentCategoryAxios';
import { getAttentionObservationsByQuery, getAttentionObservationsByQueryString } from 'components/axios/equipmentAlertsAxios';
import CustomEnumSelect from 'components/select/CustomEnumSelect';
import CustomSelect from 'components/select/CustomSelect';
import { BootstrapInput, ROLE } from 'data/data';
import { useEnumApi } from 'contexts/EnumApiContext';
import { useTranslation } from 'react-i18next';
import { fromServerFormat, nowFormat } from 'components/date_picker/dateUtils';
import { getSearchFiltersEquipmentZones } from 'components/axios/equipmentZoneAxios';
import CommonLargeExcelDownload from 'components/CommonLargeExcelDownload';
import useConfig from 'hooks/useConfig';
import usePermission from 'hooks/usePermission';
import { PERMISSIONS } from 'config/permissions';

const muiLocaleMap = {
  ko: koKR.components.MuiDataGrid.defaultProps.localeText,
  en: enUS.components.MuiDataGrid.defaultProps.localeText,
  'zh-CN': zhCN.components.MuiDataGrid.defaultProps.localeText,
};

const ObserveMaintenance = () => {
  const { getEnumValueByEnumName, getEnumValueByEnumNameAndCode, equipmentCategoryLevel1s, loginInfo } = useEnumApi();
  const { t, i18n } = useTranslation();
  const { mode } = useConfig();

  const platformServer = process.env.REACT_APP_PLATFORM_SERVER;
  const nantongCompanyId = process.env.REACT_APP_NANTONG_MANAGEMENT_COMPANY_NO;
  const lang = i18n.language.substring(0, 2);

  const navigate = useNavigate();
  const [searchField, setSearchField] = useState('name');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [pageInfo, setPageInfo] = useState({});
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(process.env.REACT_APP_DEFAULT_PAGE_SIZE);
  const [attentionObservations, setAttentionObservations] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isParam, setIsParam] = useState(false);
  // const [toggleStr, setToggleStr] = useState(true);

  //const [equipmentOpStatus, setEquipmentOpStatus] = useState('');
  //const [equipmentFaultStatus, setEquipmentFaultStatus] = useState('');
  const [observeStatus, setObserveStatus] = useState('');
  const [alertType, setAlertType] = useState('');
  const [zoneCategoryCode, setZoneCategoryCode] = useState('');
  const [zoneId, setZoneId] = useState('');
  const [equipmentCategoryLevel1Id, setEquipmentCategoryLevel1Id] = useState('');
  const [equipmentCategoryLevel2Id, setEquipmentCategoryLevel2Id] = useState('');
  const [equipmentCategoryLevel3Id, setEquipmentCategoryLevel3Id] = useState('');
 
  const [zoneCategories, setZoneCategories] = useState([]);
  const [zones, setZones] = useState([]);
  //let [equipmentCategoryLevel1s, setEquipmentCategoryLevel1s] = useState([]);
  const [equipmentCategoryLevel2s, setEquipmentCategoryLevel2s] = useState([]);
  const [equipmentCategoryLevel3s, setEquipmentCategoryLevel3s] = useState([]);

  const [sortModel, setSortModel] = useState(null);
  const excelTitle = t('menu.cmms.equipment-observe');
  const excelTopHeaders = [
    "No."
    , t('message.common.subtitle.status')
    , t('message.common.subtitle.observe.period')
    , t('message.common.subtitle.observe.regUser')
    , t('message.common.subtitle.alertedAt')
    , t('message.common.subtitle.alertType')
    , t('message.common.subtitle.alertCategory')
    , getEnumValueByEnumNameAndCode('CompanyType', 'MAN')?.[0]?.title
    , getEnumValueByEnumNameAndCode('CompanyType', 'MNT')?.[0]?.title
    , t('message.common.subtitle.equipment.level1')
    , t('message.common.subtitle.equipment.level3')
    , t('message.common.subtitle.equipment.name')
    , t('message.common.subtitle.equipment.number')
    , getEnumValueByEnumNameAndCode('CompanyType', 'MFR')?.[0]?.title
    ,t('message.common.subtitle.modelName')
  ];
  const [excelParam, setExcelParam] = useState([]);
  // const fileName = excelTitle+"_"+Date.now();
  // const [excelDatas, setExcelDatas] = useState([]);

  if (platformServer === 'NANTONG') {
    excelTopHeaders.splice(7, 2)

    // 호선, 역사 추가
    excelTopHeaders.splice(7, 0, t('message.common.subtitle.subwayline')); // 1번 인덱스에서 0개를 삭제하고 newItem을 추가
    excelTopHeaders.splice(8, 0, t('message.common.subtitle.station')); // 1번 인덱스에서 0개를 삭제하고 newItem을 추가
  }

  //const connectProblemDay = dayjs(today).subtract(7, "d").format("YYYY-MM-DD");
  const todayStr = nowFormat(t('message.common.text.date.format.date'))

  // const [searchFields] = useState([{code:"name", title:t('message.common.subtitle.equipment.name')}, {code:"equipmentNo", title:t('message.common.subtitle.equipment.number')}]);
  const searchFields = [
    {code:"name", title:t('message.common.subtitle.equipment.name')}, {code:"equipmentNo", title:t('message.common.subtitle.equipment.number')}, {code:"modelName", title:t('message.common.subtitle.modelName')}
    // , {code:"mfr", title:getEnumValueByEnumNameAndCode('CompanyType', 'MFR')?.[0]?.title}, {code:"man", title:getEnumValueByEnumNameAndCode('CompanyType', 'MAN')?.[0]?.title}, {code:"mnt", title:getEnumValueByEnumNameAndCode('CompanyType', 'MNT')?.[0]?.title}
  ];

  let qs = queryString.parse(window.location.search);
  
  let falutStatusSelectColor = "";
  let statusColor = "";
  //let diffDate = 0;
  const [searchParam, setSearchParam] = useState({});
  const [searchParamString, setSearchParamString] = useState('');

  if (observeStatus === '' || observeStatus === "sum") {
    falutStatusSelectColor = " selected";
  }
  
  const columns = [
    { field: 'no', headerName: 'No.', sortable: false, width: 80
      // , valueGetter:(params) => params.row?.no
      , renderCell:(params)=>(<Link to={'/equipment-observe/'+params.row?.id+searchParamString}>{params.row?.no}</Link>)
    },
    { field: 'status', headerName: t('message.common.subtitle.status'), sortable: true, width: 80,
      cellClassName : 'statusButton'
      , renderCell:(params)=>
        (<div style={{textAlign:"center"}} className={params.row?.status === 'V' ? 'condition2' : 'condition4'}>
            <Link to={'/equipment-observe/'+params.row?.id+searchParamString}>{getEnumValueByEnumNameAndCode("AttentionObservationStatus", params.row?.status)?.[0]?.title}</Link>
        </div>)
    },
    { field: 'endYmd', headerName: t('message.common.subtitle.observe.period'), sortable:true, width: 120
      // , valueGetter:(params)=>params.row?.endYmd
      , renderCell:(params)=>(<Link to={'/equipment-observe/'+params.row?.id+searchParamString}>{params.row?.endYmd}</Link>)
    },
    { field: 'regUser', headerName: t('message.common.subtitle.observe.regUser'), sortable:true, width: 100
      // , valueGetter:(params)=>params.row?.regUser
      , renderCell:(params)=>(<Link to={'/equipment-observe/'+params.row?.id+searchParamString}>{params.row?.regUser}</Link>)
    },
    { field: 'equipmentAlert.latestAlertedAt', headerName: t('message.common.subtitle.alertedAt'), sortable:true, width: 150
      // , valueGetter:(params)=>params.row?.equipmentAlert?.latestAlertedAt && fromServerFormat(params.row?.equipmentAlert?.latestAlertedAt, {format:t('message.common.text.date.format.datetime')})
      , renderCell:(params)=>(<Link to={'/equipment-observe/'+params.row?.id+searchParamString}>{params.row?.equipmentAlert?.latestAlertedAt && fromServerFormat(params.row?.equipmentAlert?.latestAlertedAt, {format:t('message.common.text.date.format.datetime')})}</Link>)
    },
    { field: 'equipmentAlert.alertType', headerName: t('message.common.subtitle.alertType'), sortable:true, width: 100
      // , valueGetter:(params)=>getEnumValueByEnumNameAndCode("AlertType", params.row?.equipmentAlert?.alertType)?.[0]?.title
      , renderCell:(params)=>(<Link to={'/equipment-observe/'+params.row?.id+searchParamString}>{getEnumValueByEnumNameAndCode("AlertType", params.row?.equipmentAlert?.alertType)?.[0]?.title}</Link>)
    },
    { field: 'equipmentAlert.alertCategory', headerName: t('message.common.subtitle.alertCategory'), sortable:true, width: 100
      // , valueGetter:(params)=>getEnumValueByEnumNameAndCode("AlertCategory", params.row?.equipmentAlert?.alertCategory)?.[0]?.title 
      , renderCell:(params)=>(<Link to={'/equipment-observe/'+params.row?.id+searchParamString}>{getEnumValueByEnumNameAndCode("AlertCategory", params.row?.equipmentAlert?.alertCategory)?.[0]?.title}</Link>)
    },
    { field: 'equipment.managementCompany.info.name', headerName: getEnumValueByEnumNameAndCode("CompanyType", 'MAN')?.[0]?.title, sortable:true, width: 130
      , renderCell:(params)=>(<Link to={'/equipment-observe/'+params.row?.id+searchParamString}>{params.row?.equipment?.managementCompany?.info?.name}</Link>)
    },
    { field: 'equipment.maintenanceCompany.info.name', headerName: getEnumValueByEnumNameAndCode("CompanyType", 'MNT')?.[0]?.title, sortable:true, width: 130
      , renderCell:(params)=>(<Link to={'/equipment-observe/'+params.row?.id+searchParamString}>{params.row?.equipment?.maintenanceCompany?.info?.name}</Link>)
    },
    { field: 'equipment.equipmentCtgr.parent.parent.name', headerName: t('message.common.subtitle.equipment.level1'), sortable:true, width: 120
      // , valueGetter:(params)=>params.row?.equipment?.equipmentCtgr?.parent?.parent?.name
      , renderCell:(params)=>(<Link to={'/equipment-observe/'+params.row?.id+searchParamString}>{params.row?.equipment?.equipmentCtgr?.parent?.parent?.name}</Link>)
    },
    { field: 'equipment.equipmentCtgr.name', headerName: t('message.common.subtitle.equipment.level3'), sortable:true, width: 120
      // , valueGetter:(params)=>params.row?.equipment?.equipmentCtgr?.name
      , renderCell:(params)=>(<Link to={'/equipment-observe/'+params.row?.id+searchParamString}>{params.row?.equipment?.equipmentCtgr?.name}</Link>)
    },
    { field: 'equipment.name', headerName: t('message.common.subtitle.equipment.name'), sortable:true, minWidth: 200
      // , valueGetter:(params)=>params.row?.equipment?.name 
      , renderCell:(params)=>(<Link to={'/equipment-observe/'+params.row?.id+searchParamString}>{params.row?.equipment?.name}</Link>)
    },
    { field: 'equipment.equipmentNo', headerName: t('message.common.subtitle.equipment.number'), sortable:true, width: 130
      // , valueGetter:(params)=>params.row?.equipment?.equipmentNo 
      , renderCell:(params)=>(<Link to={'/equipment-observe/'+params.row?.id+searchParamString}>{params.row?.equipment?.equipmentNo}</Link>)
    },
    { field: 'equipment.manufacturingCompany.info.name', headerName: getEnumValueByEnumNameAndCode("CompanyType", 'MFR')?.[0]?.title, sortable:true, width: 130
      , renderCell:(params)=>(<Link to={'/equipment-observe/'+params.row?.id+searchParamString}>{params.row?.equipment?.manufacturingCompany?.info?.name}</Link>)
    },
    { field: 'equipment.modelName', headerName: t('message.common.subtitle.modelName'), sortable:true, width: 80
      , renderCell:(params)=>(<Link to={'/equipment-observe/'+params.row?.id+searchParamString}>{params.row?.equipment?.modelName}</Link>)
    },
  ];

  if (platformServer === 'NANTONG') {
    // 관리주체 항목 제거
    const targetIndex = columns.findIndex(item => item.field === 'equipment.managementCompany.info.name');
    if (targetIndex !== -1) {
      columns.splice(targetIndex, 2); // targetIndex부터 1개를 삭제
    }

    // 호선, 역사 추가
    const newItem = { field: 'equipment.zone.category.code', headerName: t('message.common.subtitle.subwayline'), sortable:true, width: 80
      , renderCell:(params)=>(<Link to={'/equipment/'+params.row?.id+searchParamString}>{params.row?.equipment?.zone?.category?.name?.[i18n.language.substring(0, 2)]}</Link>)
    };
    const newItem2 = { field: 'equipment.zone.name', headerName: t('message.common.subtitle.station'), sortable:true, width: 100
      , renderCell:(params)=>(<Link to={'/equipment/'+params.row?.id+searchParamString}>{params.row?.equipment?.zone?.name}</Link>)
    };
    columns.splice(7, 0, newItem); // 1번 인덱스에서 0개를 삭제하고 newItem을 추가
    columns.splice(8, 0, newItem2); // 1번 인덱스에서 0개를 삭제하고 newItem을 추가
  }

  const handlePaging = (value) => {
    //console.log(value);
    value = isNaN(value) ? 1 : value;
    setCurrentPage(value-1);
    setIsLoading(false);

    let searchParamCopy = {...searchParam};
    searchParamCopy.page = (value-1);
    setSearchParam(searchParamCopy);
  }
  
  useEffect(()=>{
    const searchOrders = searchParam.searchOrder;
    const searchParamCopy = {...searchParam};
    // console.log(searchParam)
    // console.log(searchParamCopy)
    delete searchParamCopy.searchOrder;
    let searchString = Object.entries(searchParamCopy).map(([key, value]) => ( key+'='+value)).filter(v=>v).join('&');
    // console.log(searchString)
    if (searchOrders && searchOrders.length > 0) {
      let sortString = '';
      searchOrders.forEach(order=>sortString+="&sort="+order.sort)
      // let sortModel = [];
      // // searchOrders.map(order=>console.log(order));
      // searchOrders.map(order=>sortModel.push({"field": order.sort.split(',')[0],"sort": order.sort.split(',')[1]}))
      // // setSortModel(sortModel)
      // console.log(sortString)
      searchString += sortString;
    }
    // console.log("?"+searchString)
    setSearchParamString("?"+searchString)
  }, [searchParam])

  useEffect(()=>{
    const searchParamCopy = {...searchParam};
    // console.log(sortModel)
    let searchOrders = [];
    if (sortModel && sortModel.length > 0) {
      searchOrders.push({sort : sortModel[0].field+","+sortModel[0].sort});
    } else {
      searchOrders.push({sort : "endYmd,asc"});
      searchOrders.push({sort : "equipmentAlert.latestAlertedAt,desc"});
    }
    // delete searchParamCopy.searchOrder;
    // console.log(searchOrders)
    searchParamCopy.searchOrder = searchOrders;
    setSearchParam(searchParamCopy)
  },[sortModel])

  useEffect(()=> {
    if (qs) {
      if (qs.page && qs.page !== (currentPage)) {setCurrentPage(qs.page);}
      if (qs.size) setPageSize(qs.size);
      if (qs.searchField) setSearchField(qs.searchField);
      if (qs.searchKeyword) setSearchKeyword(qs.searchKeyword);

      if (qs.searchStatus) setObserveStatus(qs.searchStatus);
      if (qs.searchType) setAlertType(qs.searchType);
      if (qs.searchSubway) setZoneCategoryCode(qs.searchSubway);
      if (qs.searchStation) setZoneId(qs.searchStation);
      if (qs.searchlevel1) setEquipmentCategoryLevel1Id(qs.searchlevel1);
      if (qs.searchlevel2) setEquipmentCategoryLevel2Id(qs.searchlevel2);
      if (qs.searchlevel3) setEquipmentCategoryLevel3Id(qs.searchlevel3);

      
      let searchParamCopy = {...searchParam};
      if (qs.page && qs.page !== (currentPage)) {searchParamCopy.page = qs.page};
      if (qs.size) {searchParamCopy.size = qs.size} ;
      if (qs.searchField) {searchParamCopy.searchField = qs.searchField};
      if (qs.searchKeyword) {searchParamCopy.searchKeyword = qs.searchKeyword};
      if (qs.searchStatus) {searchParamCopy.searchStatus = qs.searchStatus};
      if (qs.searchType) {searchParamCopy.searchType = qs.searchType};
      if (qs.searchSubway) {searchParamCopy.searchSubway = qs.searchSubway};
      if (qs.searchStation) {searchParamCopy.searchStation = qs.searchStation};
      if (qs.searchlevel1) {searchParamCopy.searchlevel1 = qs.searchlevel1};
      if (qs.searchlevel2) {searchParamCopy.searchlevel2 = qs.searchlevel2};
      if (qs.searchlevel3) {searchParamCopy.searchlevel3 = qs.searchlevel3};
      if (qs.sort && qs.sort.length > 0) {
        // console.log(qs.sort);
        let orders = [];
        let sortModel = [];
        if (!Array.isArray(qs.sort)) {
          orders.push({sort:qs.sort});
          sortModel.push({"field": qs.sort.split(',')[0],"sort": qs.sort.split(',')[1]})
        } else {
          (qs.sort).forEach(order=>orders.push({sort:order}));
          qs.map(order=>sortModel.push({"field": order.sort.split(',')[0],"sort": order.sort.split(',')[1]}))
        }
        // console.log(sortModel)
        setSortModel(sortModel)
        searchParamCopy.searchOrder = orders;
      } else {
        delete searchParamCopy.searchOrder
      };
      // console.log(searchParamCopy)
      setSearchParam(searchParamCopy);
    }
    setIsParam(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [qs.page, qs.size, qs.searchField, qs.searchKeyword, qs.searchStatus, qs.searchType
    , qs.searchlevel1, qs.searchlevel2, qs.searchlevel3]);

  useEffect(() => {
    const fetchAndSetZones = async () => {
      const data = await getSearchFiltersEquipmentZones();
      if (!data) return;

      const company = data.managementCompanies?.find(com => com.id == nantongCompanyId);
      if (company) {
        const categories = company.zoneCategories?.map(zc => ({
          ...zc,
          title: zc.name?.[lang]
        })) ?? [];
        
        setZoneCategories(categories);

        // 카테고리 로드 직후, 현재 선택된 zoneCategoryCode가 있다면 바로 zones까지 세팅
        if (zoneCategoryCode) {
          const foundCategory = categories.find(zc => zc.code === zoneCategoryCode);
          setZones(foundCategory?.zones ?? []);
        }
      }
    };

    fetchAndSetZones();
  }, [nantongCompanyId, lang, zoneCategoryCode]); // 관련 의존성을 통합

  useEffect(()=>{
    // console.log(zoneCategories)
    if (zoneCategoryCode) {
      const zonCategory = zoneCategories?.find(zc=>zc.code === zoneCategoryCode);
      setZones(zonCategory?.zones ?? [])
      // console.log(zonCategory)
      // console.log(zonCategory?.zones ?? [])
    } else {
      setZones([])
      // console.log(111)
    }
  },[zoneCategoryCode])

  // 설비중분류 목록
  useEffect(()=>{
    if (equipmentCategoryLevel1Id) {
      const param = { "parent.id": equipmentCategoryLevel1Id, depth: 2, size : 100, sort : "name,asc" };
      getEquipmentCategoriesByQuery(param).then((data) => {
        if (data && data._embedded) {
          const list = data._embedded.equipmentCategories;
          if (list) {
            setEquipmentCategoryLevel2s(list);
          } else {
            setEquipmentCategoryLevel2s([]);
          }
        } else {
          setEquipmentCategoryLevel2s([]);
        }
        setEquipmentCategoryLevel3s([]);
      });
    }
  },[equipmentCategoryLevel1Id]);

  // 설비분류 목록
  useEffect(()=>{
    if (equipmentCategoryLevel2Id) {
      const param = { "parent.id": equipmentCategoryLevel2Id, depth: 3, size : 100, sort : "name,asc" };
      getEquipmentCategoriesByQuery(param).then((data) => {
        if (data && data._embedded) {
          const list = data._embedded.equipmentCategories;
          if (list) {
            setEquipmentCategoryLevel3s(list);
          } else {
            setEquipmentCategoryLevel3s([]);
          }
        } else {
          setEquipmentCategoryLevel3s([]);
        }
      });
    }
  },[equipmentCategoryLevel2Id]);

  // 목록
  useEffect(()=> {
    if ((!isLoading || sortModel != null) && !isNaN(currentPage) && isParam) {
      //console.log('000');
      attentionObservationList();
      // equipmentGroupCountList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, isLoading, observeStatus, isParam, sortModel]);

  let [groupCounts, setGroupCounts] = useState([]);
  let [totalGroupCount, setTotalGroupCount] = useState(0);

  // const equipmentGroupCountList = async() => {
  //   await getAttentionObservationsCountGroupByStatus().then((res)=>{
  //     //console.log('============================================');
  //     groupCounts = [];
  //     totalGroupCount = 0;
  //     if (res != null) {
  //       let isInclude = false;
  //       let statussData = res.data;

  //       setGroupCounts([{}]);
  //       if (observeStatuss) {
  //         observeStatuss.map(function(item1) {
  //           //console.log(item1);
  //           isInclude = false;
  //           statussData.map(function(item2) {
  //             //console.log(item2);
  //             if (item2.id === item1.code) {
  //               //console.log('item2.code : ' + item2.code);
  //               if (item2.count === undefined)
  //                 item2.count = 0;
  //                 //console.log('item2 : ', item2);
  //               groupCounts.push(...[item2]);
  //               totalGroupCount += item2.count;
  //               isInclude = true;
  //             }
  //           })

  //           if (!isInclude) {
  //             //console.log('============');
  //             let defaultStatus = [{
  //               name : item1.code,
  //               id : item1.code,
  //               title : item1.title,
  //               count : 0,
  //             }];
  //             groupCounts.push(...defaultStatus);
  //           }
  //         })
  //       }
  //       setGroupCounts(groupCounts);
  //       setTotalGroupCount(totalGroupCount);
  //       //console.log(equipmentGroupCounts);
  //     }
  //   });
  // }

  const attentionObservationList = (curPage=currentPage) => {
    //console.log('list');
    isNaN(curPage) && setCurrentPage(0);
    isNaN(pageSize) && setPageSize(process.env.REACT_APP_DEFAULT_PAGE_SIZE);
    setCurrentPage(curPage)

    let param = {
      // sort : "endYmd,desc,equipmentAlert.latestAlertedAt,asc",
      // sort : "endYmd,desc",
      page : curPage,
      size : pageSize
    };
    if (alertType) {
      param["equipmentAlert.alertType"] = alertType;
    }
    if (zoneCategoryCode) {
      param["equipment.zone.category.code"] = zoneCategoryCode;
    }
    if (zoneId) {
      param['equipment.zone.id'] = zoneId;
    }
    if (equipmentCategoryLevel1Id) {
      param['equipment.equipmentCtgr.parent.parent.id'] = equipmentCategoryLevel1Id;
    }
    if (equipmentCategoryLevel2Id) {
      param['equipment.equipmentCtgr.parent.id'] = equipmentCategoryLevel2Id;
    }
    if (equipmentCategoryLevel3Id) {
      param['equipment.equipmentCtgr.id'] = equipmentCategoryLevel3Id;
    }

    // param.endYmd = "gte("+todayStr+")";

    let keyword = searchKeyword;
    if (searchKeyword) {
      if (!searchField) {
        setSearchField('name')
        keyword = 'contains('+searchKeyword+')';
        param['equipment.name'] = keyword;
      } else {
        if (searchField && (searchField === 'name' || searchField === 'equipmentNo' )) {
          keyword = 'contains('+searchKeyword+')';
        }

        if (searchField === 'name') {
          param['equipment.name'] = keyword;
        } else if (searchField === 'equipmentNo') {
          param['equipment.equipmentNo'] = keyword;
        } else if (searchField === 'modelName') {
          param['equipment.modelName'] = keyword;
        }
      }
    }
    
    //console.log(param);
    // let queryString = Object.entries(param).map(([key, value]) => ( value && key+'='+value)).filter(v=>v).join('&');
    // queryString += "&sort=endYmd,asc&sort=equipmentAlert.latestAlertedAt,desc";
    // let addQueryString = "";
    // if (sortModel && sortModel.length > 0)
    //   addQueryString += "&sort="+sortModel[0].field+","+sortModel[0].sort;
    // else
    //   addQueryString += "&sort=endYmd,asc&sort=equipmentAlert.latestAlertedAt,desc";
    // // if (observeStatus === 'V') {
    // //   addQueryString += "&endYmd=isNull()";
    // // // } else if (observeStatus === 'sum') {
    // // //   queryString += "&endYmd=isNull()";
    // // //   queryString += "&endYmd=gt("+todayStr+")";
    // // //   queryString += "&endYmd=lte("+todayStr+")";
    // // }
    // addQueryString += "&endYmd=isNull()";

    // let queryString = Object.entries(param).map(([key, value]) => ( value && key+'='+value)).filter(v=>v).join('&');
    // queryString += addQueryString;


    if (sortModel && sortModel.length > 0) {
      param.sort = [sortModel[0].field+","+sortModel[0].sort];
    } else {
      param.sort = ['status,desc','endYmd,asc'];
      // param.sort = ['endYmd,asc','equipmentAlert.latestAlertedAt,desc'];
    }
    // param.endYmd = "isNull()";

    const { page, size, ...rest } = param;
    setExcelParam(rest);

    // console.log(queryString);
    Promise.all([
      getAttentionObservationsByQuery(param).then((data)=>{
        if (data != null) {
          // console.log(data);
          if(data.page) {
            setPageInfo(data.page);
          } else {
            setCurrentPage(0);
            pageInfo = {
              size : pageInfo.size,
              totalElements : 0,
              totalPages : 0,
              number : 0
            }
            setPageInfo(pageInfo);
          }
          if(data._embedded) {
            let list = data._embedded.attentionObservations;
            list && list.map(function(task, i) {
              task.idx = (i+1);
              task.no = data.page.totalElements-((currentPage)*data.page.size)-i;
            })
            // console.log(list)
            setAttentionObservations(list);
            setIsLoading(true);
            return data.page.totalElements;
            // setAttentionObservations(data._embedded.attentionObservations);
          } else {
            setAttentionObservations([]);
          }
        } else {
          pageInfo = {
            size : pageInfo.size,
            totalElements : 0,
            totalPages : 0,
            number : 0
          }
          setPageInfo(pageInfo);
          setAttentionObservations([]);
        }
        setIsLoading(true);
        return 0;
      })
    ])
    // .then((res)=>{
    //   // console.log(res);
    //   const totalCount = res[0];
    //   if (totalCount) {
    //     // console.log(totalCount)
    //     delete param.page;
    //     param.page = 0;
    //     delete param.size;
    //     param.size = totalCount;
    //     queryString = Object.entries(param).map(([key, value]) => (value && key + '=' + value)).filter(v => v).join('&');
    //     queryString += addQueryString;
    //     // console.log(queryString)
    //     getAttentionObservationsByQueryString("?"+queryString).then((data)=>{
    //       if (data != null) {
    //       //  console.log(data);
    //         if(data._embedded) {
    //           let list = data._embedded.attentionObservations;
    //           let excelDatas = [];
    //           let excelData = [];
    //           list && list.forEach(function (column, a) {
    //             excelData = [
    //                 (data.page.totalElements-a),
    //                 ((getEnumValueByEnumNameAndCode("AttentionObservationStatus", column?.status)?.[0]?.title) || ''),
    //                 ((column.endYmd) || ''),
    //                 ((column.regUser) || ''),
    //                 ((column.equipmentAlert?.latestAlertedAt && fromServerFormat(column.equipmentAlert?.latestAlertedAt, {format:t('message.common.text.date.format.datetime')})) || ''),
    //                 ((getEnumValueByEnumNameAndCode("AlertType", column.equipmentAlert?.alertType)?.[0]?.title) || ''),
    //                 ((getEnumValueByEnumNameAndCode("AlertCategory", column.equipmentAlert?.alertCategory)?.[0]?.title) || ''),
    //                 ((column.equipment?.managementCompany?.info?.name) || ''),
    //                 ((column.equipment?.maintenanceCompany?.info?.name) || ''),
    //                 ((column.equipment?.equipmentCtgr?.parent?.parent?.name) || ''),
    //                 ((column.equipment?.equipmentCtgr?.name) || ''),
    //                 ((column.equipment?.name) || ''),
    //                 ((column.equipment?.equipmentNo) || ''),
    //                 ((column.equipment?.manufacturingCompany?.info?.name) || ''),
    //                 ((column.equipment?.modelName) || '')
    //             ];
    //             if (platformServer === 'NANTONG') {
    //               excelData.splice(7, 2)

    //               // 호선, 역사 추가
    //               excelData.splice(7, 0, ((column.equipment?.zone?.category?.name?.[i18n.language.substring(0, 2)]) || '')); // 1번 인덱스에서 0개를 삭제하고 newItem을 추가
    //               excelData.splice(8, 0, ((column.equipment?.zone?.name) || '')); // 1번 인덱스에서 0개를 삭제하고 newItem을 추가
    //             }
                
    //             excelDatas.push(excelData);
    //           });
    //           // console.log(excelDatas)
    //           setExcelDatas(excelDatas);
    //         } else {
    //           setExcelDatas([]);
    //         }
    //       } else {
    //         setExcelDatas([]);
    //       }
    //     })
    //   } else {
    //     setExcelDatas([]);
    //   }
    // })
  }

  const dataMappingRules = (column, index, totalElements, startIndex) => {
    const rowNumber = totalElements - (startIndex + index);

    let rowData = [
      rowNumber,
      ((getEnumValueByEnumNameAndCode("AttentionObservationStatus", column?.status)?.[0]?.title) || ''),
      ((column.endYmd) || ''),
      ((column.regUser) || ''),
      ((column.equipmentAlert?.latestAlertedAt && fromServerFormat(column.equipmentAlert?.latestAlertedAt, {format:t('message.common.text.date.format.datetime')})) || ''),
      ((getEnumValueByEnumNameAndCode("AlertType", column.equipmentAlert?.alertType)?.[0]?.title) || ''),
      ((getEnumValueByEnumNameAndCode("AlertCategory", column.equipmentAlert?.alertCategory)?.[0]?.title) || ''),
      ((column.equipment?.managementCompany?.info?.name) || ''),
      ((column.equipment?.maintenanceCompany?.info?.name) || ''),
      ((column.equipment?.equipmentCtgr?.parent?.parent?.name) || ''),
      ((column.equipment?.equipmentCtgr?.name) || ''),
      ((column.equipment?.name) || ''),
      ((column.equipment?.equipmentNo) || ''),
      ((column.equipment?.manufacturingCompany?.info?.name) || ''),
      ((column.equipment?.modelName) || '')
    ];

    return rowData;
  };
 
  const handleInput = (event) => {
    event.preventDefault();
    setSearchKeyword(event.target.value.trim());
  };

  const handleOnKeyPress = e => {
    if (e.key === 'Enter') {
      handleSearch(e); // Enter 입력이 되면 클릭 이벤트 실행
    }
  };

  const handleSearch = (event) => {
    event.preventDefault();
    setCurrentPage(0);
    pageInfo.number = 0;
    setPageInfo(pageInfo);
    attentionObservationList(0);
    // setExcelDatas([]);

    let searchParamCopy = {...searchParam};
    searchParamCopy.page = 0;
    if (pageSize) {searchParamCopy.size = pageSize};
    if (searchField) {searchParamCopy.searchField = searchField};
    if (searchKeyword) {searchParamCopy.searchKeyword = searchKeyword};
    if (observeStatus) {searchParamCopy.searchStatus = observeStatus};
    if (alertType) {searchParamCopy.searchType = alertType};
    if (zoneCategoryCode) {searchParamCopy.searchSubway = zoneCategoryCode};
    if (zoneId) {searchParamCopy.searchStation = zoneId};
    if (equipmentCategoryLevel1Id) {searchParamCopy.searchlevel1 = equipmentCategoryLevel1Id};
    if (equipmentCategoryLevel2Id) {searchParamCopy.searchlevel2 = equipmentCategoryLevel2Id};
    if (equipmentCategoryLevel3Id) {searchParamCopy.searchlevel3 = equipmentCategoryLevel3Id};
    setSearchParam(searchParamCopy)
    const paramString = Object.entries(searchParamCopy).map(([key, value]) => ( key+'='+value)).filter(v=>v).join('&');
    navigate("?"+paramString)
  };

  const typeTapSearch = (vCode) => {
    //console.log(vCode);
    setCurrentPage(0);
    pageInfo.number = 0;
    setPageInfo(pageInfo);
    //if (vCode && vCode !== 'sum') {
      setObserveStatus(vCode);
    //} else {
    //  setEquipmentFaultStatus('');
    //}
    initSearch();
    //attentionObservationList();
    
    let searchParamCopy = {...searchParam};
    searchParamCopy.page = 0;
    if (pageSize) {searchParamCopy.size = pageSize};
    if (searchField) {searchParamCopy.searchField = searchField};

    searchParamCopy.searchKeyword = '';
    searchParamCopy.searchStatus = vCode;
    searchParamCopy.searchType = '';
    searchParamCopy.searchSubway = '';
    searchParamCopy.searchStation = '';
    searchParamCopy.searchlevel1 = '';
    searchParamCopy.searchlevel2 = '';
    searchParamCopy.searchlevel3 = '';
    setSearchParam(searchParamCopy);
    const paramString = Object.entries(searchParamCopy).map(([key, value]) => ( key+'='+value)).filter(v=>v).join('&');
    navigate("?"+paramString)
  };

  const initSearch = ()  => {
    //console.log('aaaa');
    //setObserveStatus('');
    setAlertType('');
    setZoneCategoryCode('');
    setZoneId('');
    setEquipmentCategoryLevel1Id('');
    setEquipmentCategoryLevel2Id('');
    setEquipmentCategoryLevel3Id('');
    //setSearchField('');
    // setToggleStr(!toggleStr);
    setCurrentPage(0);
    setSearchKeyword('');
    //searchKeywordRef.current.defaultValue = '';
    // setTimeout(() => {
    //   console.log('tabSearch');
    // }, 1000);
    setIsLoading(false);
    // setExcelDatas([]);
  };
  
  const { hasPermission } = usePermission();
  const equipmentCategorySearchPermission = hasPermission(PERMISSIONS.EQUIPMENT_CATEGORY_SEARCH);
  return (
    <div className="sub_container">
      <div className='search_section'>
        <div className="selectbox">
          <div className="desktop_serach">
            
            <Box component="form" >
              <div>
                <div>
                  {getEnumValueByEnumName("AlertType") && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomEnumSelect
                      key={alertType}
                      label={t('message.common.subtitle.alertType')}
                      labelName={t('message.common.subtitle.alertType')}
                      name={'alertType'}
                      defaultValue={alertType}
                      onChange={(e)=>{
                        setAlertType(e.target.value);
                      }}
                      list={getEnumValueByEnumName("AlertType")}
                  />
                  </FormControl>
                  }
                  {(platformServer === 'NANTONG' && zoneCategories) &&
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomEnumSelect
                      key={`${zoneCategoryCode}-${zoneCategoryCode.length}`}
                      label={t('message.common.subtitle.subwayline')}
                      labelName={t('message.common.subtitle.subwayline')}
                      name={'subway'}
                      defaultValue={zoneCategoryCode}
                      onChange={(e)=>{
                        setZoneCategoryCode(e.target.value);
                        setZoneId('')
                      }}
                      list={zoneCategories}
                  />
                  </FormControl>
                  }
                  {(platformServer === 'NANTONG' && zones ) && (
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomSelect
                      key={`${zoneId}-${zones.length}`}
                      label={t('message.common.subtitle.station')}
                      labelName={t('message.common.subtitle.station')}
                      name={'station'}
                      value={zoneId}
                      // defaultValue={zones ? zoneId : ''}
                      onChange={(e)=>{
                        setZoneId(e.target.value)
                      }}
                      list={zones}
                  />
                  </FormControl>
                  )}
                  {equipmentCategorySearchPermission && equipmentCategoryLevel1s && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomSelect
                      key={equipmentCategoryLevel1Id}
                      label={t('message.common.subtitle.equipment.level1')}
                      labelName={t('message.common.subtitle.equipment.level1')}
                      name={'level1'}
                      defaultValue={equipmentCategoryLevel1Id}
                      onChange={(e)=>{
                        setEquipmentCategoryLevel1Id(e.target.value);
                        setEquipmentCategoryLevel2Id('');
                        setEquipmentCategoryLevel3Id('');
                      }}
                      list={equipmentCategoryLevel1s}
                  />
                  </FormControl>
                  }
                  {equipmentCategorySearchPermission && equipmentCategoryLevel2s && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomSelect
                      key={equipmentCategoryLevel2Id}
                      label={t('message.common.subtitle.equipment.level2')}
                      labelName={t('message.common.subtitle.equipment.level2')}
                      name={'level2'}
                      defaultValue={equipmentCategoryLevel2Id}
                      onChange={(e)=>{
                        setEquipmentCategoryLevel2Id(e.target.value);
                        setEquipmentCategoryLevel3Id('');
                      }}
                      list={equipmentCategoryLevel2s}
                  />
                  </FormControl>
                  }
                  {equipmentCategorySearchPermission && equipmentCategoryLevel3s && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomSelect
                      key={equipmentCategoryLevel3Id}
                      label={t('message.common.subtitle.equipment.level3')}
                      labelName={t('message.common.subtitle.equipment.level3')}
                      name={'level3'}
                      defaultValue={equipmentCategoryLevel3Id}
                      onChange={(e)=>{
                        setEquipmentCategoryLevel3Id(e.target.value);
                      }}
                      list={equipmentCategoryLevel3s}
                  />
                  </FormControl>
                  }
                  <div style={{display:"inline-block"}}>
                  {searchFields && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomEnumSelect
                      key={searchField}
                      label={t('message.common.btn.search')}
                      labelName={t('message.common.btn.search')}
                      name={'searchField'}
                      defaultValue={searchField}
                      onChange={(e)=>{
                        setSearchField(e.target.value);
                      }}
                      list={searchFields}
                  />
                  </FormControl>
                  }
                  
                    <FormControl sx={{ m: 1 }} variant="standard">
                      <BootstrapInput id="demo-customized-textbox" className='search_11' style={{ width : "130px" }} value={searchKeyword} onChange={handleInput} onKeyPress={handleOnKeyPress}/>
                    </FormControl>

                    <Button variant="contained" style={{marginTop:"0",padding:"10px 15px"}} onClick={handleSearch}>
                      <span className="icon_png"><img src={`${process.env.PUBLIC_URL}/img/icon/search.png`} alt='' /></span>{t('message.common.btn.search')}
                    </Button>
                  </div>
                </div>
              </div>
            </Box>
          </div>
        </div>
      </div>

      <Box 
          id="tableDiv"
          sx={{
            mt: 3,
            padding: "20px",
            borderRadius: "20px",
            overflow: "hidden",
            background: `${mode === 'dark' ? "#182131": "#fff"}`,
            border: `${mode === 'dark' ? "1px solid rgba(255,255,255,0.06)": "1px solid #30363d"}`,
            boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
          }}
        >
        <DataGridPro
          rows={attentionObservations && attentionObservations !== undefined ? attentionObservations : []}
          columns={columns}
          // onRowClick={(params, event)=>{navigate('/equipment-observe/'+params.row.id+searchParamString)}}// 상세정보 없을 경우 제외
          // onRowSelected={(e)=>{console.log(e)}}
          disableColumnFilter
          sortModel={sortModel || []}
          onSortModelChange={setSortModel}
          localeText={muiLocaleMap[i18n.language] ?? enUS.components.MuiDataGrid.defaultProps.localeText}
          sx={{
            "& .MuiDataGrid-footerContainer, & .MuiDataGrid-toolbarContainer": {
              display: "none",
            },
            "& .MuiDataGrid-cell.statusReport" : {overflow:"unset !important"}
          }}
        />

        <div className="btn_right">
          <div className='no-print-page'>
              <CommonLargeExcelDownload 
                title={excelTitle}
                excelHeader={excelTopHeaders}
                excelParam={excelParam}
                fetchApiFn={getAttentionObservationsByQuery} // 👈 액시오스 함수 매핑
                mappingFn={dataMappingRules}               // 👈 파싱 룰 데이터 매핑
                apiKey="attentionObservations"                          // 👈 JSON 응답 타겟 키 지정
                pageSize={5000}                                   // 백엔드 제한 수치 수용
                totalCount={pageInfo.totalElements}
              />
          </div>
        </div>

        <PageInfo pageInfo={pageInfo} handlePaging={handlePaging}/>
      </Box>
    </div>
  );
}
 
export default ObserveMaintenance;